import { render, staticRenderFns } from "./StockPrintTicketTpl2.vue?vue&type=template&id=05b8d04c&scoped=true&"
import script from "./StockPrintTicketTpl2.vue?vue&type=script&lang=js&"
export * from "./StockPrintTicketTpl2.vue?vue&type=script&lang=js&"
import style0 from "./StockPrintTicketTpl2.vue?vue&type=style&index=0&id=05b8d04c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b8d04c",
  null
  
)

export default component.exports